import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { scenarioThreeAPI } from 'api/scenarioThreeAPI';
import produce from 'immer';

export const fetchOutliersData = createAsyncThunk(
    'scenarioThree/fetchOutliersData',
    async (params) => await scenarioThreeAPI.fetchOutliersData(params)
);
export const fetchVcData = createAsyncThunk(
    'scenarioThree/fetchVcData',
    async (params) => await scenarioThreeAPI.fetchVcData(params)
);

export const fetchTrendData = createAsyncThunk(
    'scenarioThree/fetchTrendData',
    async (params) => await scenarioThreeAPI.fetchTrendData(params)
);

export const fetchDetailedViewData = createAsyncThunk(
    'scenarioThree/fetchDetailedViewData',
    async (data) => await scenarioThreeAPI.fetchDetailedViewData(data)
);

const scenarioThreeSlice = createSlice({
    name: 'scenarioThree',
    initialState: {
        stats: null,
        outlierData: null,
        vcData: null,
        trendData: null,
        detailedViewData: null,
        vcIsFetched: false,
        trendIsFetched: false,
        detailedViewIsFetched: false,
        outlierChartPage: 1
    },
    reducers: {
        switchOutlierChartPage: (state, { payload }) =>
            produce(state, (draft) => {
                draft.outlierChartPage = payload;
            })
    },
    extraReducers: (builder) => {
        builder.addCase(fetchOutliersData.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { outlierData } = payload;
                draft.outlierData = outlierData;
            })
        );
        builder.addCase(fetchVcData.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                const { vcChart, statsReporting } = payload;
                draft.vcData = vcChart;
                draft.stats = statsReporting;
                draft.vcIsFetched = true;
            })
        );
        builder.addCase(fetchTrendData.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                draft.trendData = payload;
                draft.trendIsFetched = true;
            })
        );
        builder.addCase(fetchDetailedViewData.fulfilled, (state, { payload }) =>
            produce(state, (draft) => {
                draft.detailedViewData = payload;
                draft.detailedViewIsFetched = true;
            })
        );
    }
});

const { actions, reducer: scenarioThreeReducer } = scenarioThreeSlice;
export const { switchOutlierChartPage } = actions;
export default scenarioThreeReducer;
